module.exports = __webpack_public_path__ + "img/logoEscolaTransparent.aa627197.svg";